module.exports = __webpack_public_path__ + "4cc62a1ba0ee4c6b4686774ce653894c.jpg";